(function ($) {
    $(document).ready(function () {

        // Slick Track Attribute
        $('.snowSlides .slick-track').attr("aria-label", "homepage-slider");
        $('.hero .slick-track').attr("aria-label", "hero-slide");
        $('.product__thumb-item').attr("tabindex", - 1);
        $('.product__thumb-item').removeAttr("aria-hidden");
        $('.product__photos .slick-track').attr("aria-label", "product-photos");

    });
})(jQuery);